// styles
export const styles = {
  workingHours: {},
  fragmentedTime: {},
};
